module.exports = __webpack_public_path__ + "img/HR23057039320.121920b7.png";